import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Fatca, FatcaManager } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-fatca-single-manager',
    templateUrl: './full-data-form-fatca-single-manager.component.html',
    styleUrls: ['./full-data-form-fatca-single-manager.component.scss']
})
export class FullDataFormFatcaSingleManagerComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public prefix: string;
    public adding = false;
    public editing = false;
    public currentFatcaManager: FatcaManager;
    public fatcaManagersComplete = false;

    @Input()
    fatca: Fatca;

    @Input()
    isDisabled = false;


    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.fatcaManagersComplete = this.fatca.managers.length > 0;
        this.prefix = `tffsman-${nextUniqueId++}-`;

        if (this.fatca.managers.length === 0) {
            this.onAdd();
        }
    }

    onResize() {
        this.parentEvents.resize();
    }

    onAdd() {
        this.currentFatcaManager = new FatcaManager();
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.fatca.addManager(this.currentFatcaManager);
            this.fatcaManagersComplete = true;
        } else if (this.editing) {
            this.fatca.updateManager(this.currentFatcaManager);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentFatcaManager = undefined;

        this.parentEvents.resize();
    }

    onEdit(fatcaManager: FatcaManager) {
        this.currentFatcaManager = cloneDeep(fatcaManager);
        this.editing = true;
        this.adding = false;
    }

    onRemove(fatcaManager: FatcaManager) {
        this.fatca.removeManager(fatcaManager);

        if (this.currentFatcaManager && this.currentFatcaManager.id.value === fatcaManager.id.value) {
            this.onCancel();
        }

        if (!this.adding && this.fatca.managers.length === 0) {
            this.onAdd();
        }

        this.fatcaManagersComplete = this.fatca.managers.length > 0;
        this.parentEvents.resize();
    }
}
